import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import TickIcon from '@clearscore/icons.tick';

import baseStyles from './styles.css';

function ProgressIndicatorWithNumber({ active, step, completed, overlay }) {
    const stepProgress = cx(baseStyles.stepProgress, {
        [baseStyles.active]: active,
        [baseStyles.overlay]: overlay,
    });

    const stepAnimation = cx(baseStyles.stepAnimation, {
        [baseStyles.completed]: completed,
    });

    const tickClass = cx({
        [baseStyles.svg]: completed,
    });

    const size = '1em';
    return (
        <div className={baseStyles.stepContainer} data-qa={`progressStep-${step}-${active ? 'active' : 'inactive'}`}>
            <div className={stepProgress}>{step}</div>
            <div className={stepAnimation}>
                <TickIcon height={size} width={size} className={tickClass} />
            </div>
        </div>
    );
}

ProgressIndicatorWithNumber.propTypes = {
    /** @type {number} step number to display */
    step: PropTypes.number,
    /** @type {boolean} is the step active */
    active: PropTypes.bool,
    /** @type {boolean} is the step completed */
    completed: PropTypes.bool,
    /** @type {boolean} is the component overlay */
    overlay: PropTypes.bool,
};

ProgressIndicatorWithNumber.defaultProps = {
    step: 0,
    active: false,
    completed: false,
    overlay: false,
};

export default ProgressIndicatorWithNumber;
